// extracted by mini-css-extract-plugin
module.exports = {"portalsNotificatonsContainer":"portalsNotifications_portalsNotificatonsContainer__xperq","separator":"portalsNotifications_separator__qajnm"};